import { useMutation } from '@tanstack/react-query'
import { UpdateSimpleMovement } from '../../../infra/requests/LogisticsRequests'
import { QUERY_KEYS } from '../../../infra/constants/QueryKeys'

export const useUpdateSimpleMovement = (id) => {
    const mutation = useMutation({
        mutationKey: [QUERY_KEYS.UpdateSimpleMovement, id],
        mutationFn: (payload) => UpdateSimpleMovement(id, payload),
    })

    return {
        updateMovement: mutation.mutate,
        isUpdating: mutation.isPending,
    }
}